import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IDeleteDocSetModel, IDeleteSchDefModel, IDocSetModel, IDocsetReviseInputModel, IDocSetRevisionDetailsInputModel, IPorjectInputModel, IScheduleDefinitionModel } from "src/app/ViewModel/ScheduleDefinitionModel";
import { RestApiService } from "../rest-api.service";
import { environment } from 'src/environments/environment';
import { CommonService } from '../Common.service';
import { HttpClient } from '@angular/common/http';
import { EncryptDecryptService } from '../encrypt-decrypt.service';
@Injectable()
export class ScheduleDefinitionService {
    private endPoints = {
        scheduleDefList: 'ScheduleDefinition/GetScheduleDefinitionDetails',
        insertUpdateSchDef: 'ScheduleDefinition/InsertUpdateScheduleDefinitionDetails',
        docSetList: 'ScheduleDefinition/GetDocumentSetDetails',
        docSetListByGroup: 'ScheduleDefinition/GetDocSetDetailsByGroup',
        insertUpdateDocSet: 'ScheduleDefinition/InsertUpdateDocumentSetDetails',
        deleteDocSet:'ScheduleDefinition/DeleteDocSet',
        deleteSchDef:'ScheduleDefinition/DeleteSchDef',
        docSetExcelTemplate: '/ScheduleDefinition/DownloadDocSetTemplate',
        docSetExcelUpload: '/ScheduleDefinition/UploadDocSetTemplate',
        schDefExcelTemplate: '/ScheduleDefinition/DownloadSchDefTemplate',
        schDefExcelUpload: '/ScheduleDefinition/UploadSchDefTemplate',
        engSchExcelTemplate: '/ScheduleDefinition/DownloadEngSchTemplate',
        engSchExcelUpload: '/ScheduleDefinition/UploadEngSchTemplate',
        docsetRevise : 'ScheduleDefinition/InsertDCIScheduleRevDetails',
        updateDocsetRevis : 'ScheduleDefinition/UpdateDCIScheduleRevisedDocDetails'
    }

    constructor(private encryptDecryptService: EncryptDecryptService, private restAPIService: RestApiService, private commonService: CommonService, private http: HttpClient) { }

    /**
     * Get Schedule Defintion Detail
     * @param project_Id 50
     */
    public getScheduleDefintionList(input: IPorjectInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.scheduleDefList, input);
    }

    /**
     * Insert/Update Schedule definition
     * @param scheduleDef 
     * @returns 
     */
    public insertUpdateSchDef(scheduleDef: IScheduleDefinitionModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchDef, scheduleDef);
    }

    /**
     * Get Schedule Defintion Detail
     * @param project_Id 50
     */
    public getDocSetList(input: IPorjectInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.docSetList, input);
    }

    public getDocSetListByGroup(input: IPorjectInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.docSetListByGroup, input);
    }

    /**
     * Insert/Update Doc Set
     * @param docSet DocSet
     * @returns 
     */
    public insertUpdateDocSet(docSet: IDocSetModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateDocSet, docSet);
    }

    public deleteDocSet(deleteDocSet : IDeleteDocSetModel):Observable<any>{
        return this.restAPIService.new_POST(this.endPoints.deleteDocSet,deleteDocSet);
    }

    public deleteSchDef(deleteSchDef:IDeleteSchDefModel):Observable<any>{
        return this.restAPIService.new_POST(this.endPoints.deleteSchDef,deleteSchDef);
    }

    public insertDocsetRevise(docsetRevise : IDocsetReviseInputModel):Observable<any>{
        return this.restAPIService.new_POST(this.endPoints.docsetRevise,docsetRevise)
    }

    public updateDCIScheduleRevisedDocDetails(updateDocsetRevise: IDocSetRevisionDetailsInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.updateDocsetRevis, updateDocsetRevise)
    }

    public GetDocSetExcelTemplate(dciExcelInput: IPorjectInputModel): Observable<Blob> {
        let _apiURL = environment.uriHost + this.endPoints.docSetExcelTemplate;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, dciExcelInput, { 'headers': headers, responseType: 'blob' });
    }

    public UploadDocSetExcelTemplate(formData: FormData): Observable<any> {
        let _apiURL = environment.uriHost + this.endPoints.docSetExcelUpload;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(_apiURL, formData, { 'headers': headers });
    }

    public GetSchDefExcelTemplate(dciExcelInput: IPorjectInputModel): Observable<Blob> {
        let _apiURL = environment.uriHost + this.endPoints.schDefExcelTemplate;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, dciExcelInput, { 'headers': headers, responseType: 'blob' });
    }

    public UploadSchDefEExcelTemplate(formData: FormData): Observable<any> {
        let _apiURL = environment.uriHost + this.endPoints.schDefExcelUpload;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(_apiURL, formData, { 'headers': headers });
    }

    public GetEngSchExcelTemplate(dciExcelInput: IPorjectInputModel): Observable<Blob> {
        let _apiURL = environment.uriHost + this.endPoints.engSchExcelTemplate;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, dciExcelInput, { 'headers': headers, responseType: 'blob' });
    }

    public UploadEngSchExcelTemplate(formData: FormData): Observable<any> {
        let _apiURL = environment.uriHost + this.endPoints.engSchExcelUpload;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(_apiURL, formData, { 'headers': headers });
    }
}